import { useAuth0 as useAuth0Original } from '@auth0/auth0-react';
import { useCallback, useRef } from 'react';

const getAudience = () => process.env.REACT_APP_AUTH0_AUDIENCE;

/**
 * App-wide Auth0 hook. Routes all silent token requests through one wrapper so
 * audience defaults stay consistent.
 */
export function useAuth0() {
  const auth0 = useAuth0Original();
  const auth0Ref = useRef(auth0);
  auth0Ref.current = auth0;

  const getAccessTokenSilently = useCallback(async (options = {}) => {
    return auth0Ref.current.getAccessTokenSilently({
      audience: getAudience(),
      ...options
    });
  }, []);

  const getIdTokenClaims = useCallback(async (options = {}) => {
    return auth0Ref.current.getIdTokenClaims({
      audience: getAudience(),
      ...options
    });
  }, []);

  return {
    ...auth0,
    getAccessTokenSilently,
    getIdTokenClaims
  };
}
